module.exports = __webpack_public_path__ + "img/Flow.b801f6a5.png";